<template>
  <div class="bottom-loader" v-if="!close">
    <img src="../../static/img/panda@2x.png" class="bottom-img" />
    <div class="bottom-text">
      <p class="bottom-text1">熊猫签证</p>
      <p class="bottom-text2">足不出户办签证</p>
    </div>
    <div class="bottom-conment">
      <div>
        <div class="bottom-star">
          <stars :score="score"></stars>
        </div>
        <div class="good">(好评<span v-text="favorableComment"></span>)</div>
      </div>
    </div>
    <div class="bottom-download">
      <a :href="downloadUrl">
        <img src="../../static/img/download@2x.png" />
      </a>
      <div class="bottom-close" v-on:click="closeCallback">
        <img src="../../static/img/close@2x.png" />
      </div>
    </div>
  </div>
</template>

<script>
import stars from './stars';

export default {
  name: 'appDownLoad',
  data() {
    return {
      score: 5,
      favorableComment: 2197,
      close: false,
    };
  },
  props: {
    channel: {
      type: String,
    },
  },
  computed: {
    downloadUrl() {
      return `https://api.11visa.com/oss/open/channel_stat?channel=${this.channel}`;
    },
  },
  components: {
    stars,
  },
  methods: {
    closeCallback() {
      this.close = true;
    },
  },
};
</script>

<style scoped lang="less">
.bottom-loader {
  position: fixed;
  bottom: 0px;
  left: 0;
  height: 0.64rem;
  width: 100%;
  background: rgba(255, 255, 255, 0.8);
  border-top: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  z-index: 9999;
  font-size: 0;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
  .bottom-img {
    display: block;
    width: 0.42rem;
    height: 0.42rem;
    margin-left: 0.15rem;
  }
  .bottom-text {
    height: 0.42rem;
    margin-left: 0.08rem;
    .bottom-text1 {
      font-size: 0.16rem;
      line-height: 0.18rem;
      color: #444444;
      margin-top: 0.05rem;
    }
    .bottom-text2 {
      font-size: 0.12rem;
      line-height: 0.18rem;
      color: #aaaaaa;
    }
  }
  .bottom-conment {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 0.6rem;
    font-size: 0.1rem;
    color: #eaeaea;
    .bottom-star {
      font-size: 0;
      margin-bottom: 0.05rem;
    }
    .good {
      text-align: left;
      color: #6f6f6f;
      font-size: 0.1rem;
      color: #6f6f6f;
    }
  }
  .bottom-download {
    width: 1rem;
    height: 0.32rem;
    text-align: right;
    display: flex;
    align-items: center;
    a {
      font-size: 0;
      img {
        width: 0.7rem;
        height: 0.32rem;
      }
    }
    .bottom-close {
      img {
        width: 0.15rem;
        height: 0.15rem;
        margin-left: 0.1rem;
      }
    }
  }
}
@media screen and (min-width: 768px) {
  .bottom-loader {
    width: 6.4rem;
  }
}
</style>
